/**
 * Owner-requested (2026-08-28): "a set format for the phone number field
 * instead of it being almost free form." Live, as-you-type formatting for
 * the two places a brand-new phone number is most commonly first typed
 * (`AddTenantDialog`, `AddVendorDialog`) — a direct TypeScript mirror of
 * `app.domain.contacts.phone.format_mobile_phone`'s own exact rule, so the
 * frontend and backend can never disagree about what counts as a real
 * number: once typing reduces to a real 10-digit US number (an optional
 * leading `1` country code stripped), it snaps to `"(NNN) NNN-NNNN"`.
 *
 * **Deliberately does nothing to anything else.** A value that is not yet
 * (or is never going to be) a real 10-digit number is returned completely
 * untouched — no partial masking, no stripped punctuation. Tried a
 * progressive "format as you go" mask first and reverted it: it mangled a
 * genuinely non-standard number (this codebase's own `"555-0199"`-style
 * fictional test numbers among them, live-caught by `VendorsList.test.tsx`
 * asserting the raw value survives) into a confusing half-formatted
 * shape, the exact inconsistency `format_mobile_phone`'s own "permissive,
 * not a validity gate" design was written to avoid on the backend.
 */
export function formatMobilePhoneInput(value: string): string {
  const digits = value.replace(/\D/g, "");
  const tenDigits = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (tenDigits.length !== 10) {
    return value;
  }
  return `(${tenDigits.slice(0, 3)}) ${tenDigits.slice(3, 6)}-${tenDigits.slice(6, 10)}`;
}
